<template>
  <v-btn
    v-if="to || href"
    :color="buttonColor"
    :class="customClass"
    @click="handleClick"
    :href="href"
    :id="id"
    :type="type"
    :block="block"
    :large="large"
    :small="small"
    :to="to"
    :flat="flat"
    :round="round"
    :outline="outline"
    :fab="fab"
    :icon="icon"
    :dark="dark"
    depressed
  >
    <span v-if="text">
      {{ text }}
    </span>
    <CSSVGIcon
      v-if="iconName"
      :iconName="iconName"
      :classes="[
        iconClass,
        'btn__icon',
        { 'btn__icon--left': iconLeft, 'btn__icon--flat': flat },
      ]"
    />
  </v-btn>
  <v-btn
    v-else
    :color="buttonColor"
    :class="[customClass, { 'btn--iconLeft': iconLeft }]"
    @click.prevent="handleClick"
    :href="href"
    :id="id"
    :type="type"
    :block="block"
    :large="large"
    :small="small"
    :to="to"
    :flat="flat"
    :round="round"
    :outline="outline"
    :fab="fab"
    :icon="icon"
    :loading="loading"
    :disabled="loading || disabled"
    :dark="dark"
    depressed
  >
    <span v-if="text">
      {{ text }}
    </span>
    <CSSVGIcon
      v-if="iconName"
      :iconName="iconName"
      :classes="[
        iconClass,
        'btn__icon',
        { 'btn__icon--left': iconLeft, 'btn__icon--flat': flat },
      ]"
    />
    <slot></slot>
  </v-btn>
</template>

<script>
import CSSVGIcon from '@/components/atoms/icons/CSSVGIcon.vue'

export default {
  name: 'CSButton',

  components: {
    CSSVGIcon,
  },

  props: {
    text: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    customClass: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: true,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: '',
    },
    depressed: {
      type: Boolean,
      required: false,
    },
    onClick: {
      type: Function,
      required: false,

      default() {
        return true
      },
    },
    block: {
      type: Boolean,
      required: false,
      default: false,
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    flat: {
      type: Boolean,
      required: false,
      default: false,
    },
    round: {
      type: Boolean,
      required: false,
      default: true,
    },
    outline: {
      type: Boolean,
      required: false,
    },
    fab: {
      type: Boolean,
      required: false,
    },
    icon: {
      type: Boolean,
      required: false,
    },
    to: {
      default: '',
    },
    href: {
      default: '',
    },
    loading: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    dark: {
      type: Boolean,
    },

    iconName: {
      type: String,
      default: '',
      required: false,
    },

    iconLeft: {
      type: Boolean,
      required: false,
      default: false,
    },

    iconClass: {
      type: [String, Array],
      default: '',
      required: false,
    },
  },

  methods: {
    handleClick() {
      this.onClick()
      this.$emit('click')
    },
  },
  computed: {
    buttonColor() {
      return !this.flat ? this.color : ''
    },
  },
}
</script>
